import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { auth } from "./pages/firebase";
import { signInWithCustomToken, onAuthStateChanged } from "firebase/auth";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import Ap_HTU from "./pages/Ap_HTU";
import Ap_Profile from "./pages/Ap_Profile";
import Gst_form from "./pages/Gst_form";
import Pricing from "./components/Pricing";
import Heading from "./components/Heading";
import HelpPage from "./components/HelpPage";
import GSTReconciliationProduct from "./components/GSTReconciliationProduct";
import RequestDemoPage from "./components/RequestDemoPage";
import About from "./components/About";
import PrivateRoute from "./components/PrivateRoute";
import HelpGuide from "./components/HelpGuide";
import { RedirectToMYOB } from './components/RedirectToMYOB';
import FileUpload from './pages/FileUpload';
import LedgerPro from "./components/LedgerPro.tsx";

const isAuthenticated = () => {
  return localStorage.getItem("authToken") !== null;
};

function App() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Handle Xero OAuth redirect
    const urlParams = new URLSearchParams(location.search);
    const uid = urlParams.get("uid");
    const token = urlParams.get("token");

    if (uid && token) {
      signInWithCustomToken(auth, token)
        .then((userCredential) => {
          localStorage.setItem("authToken", userCredential.user.accessToken);
          toast.success("Xero login successful", { position: "top-center" });
          navigate("/acc_profile", { replace: true }); // Clean URL
        })
        .catch((error) => {
          console.error("Custom Token Sign-in Error:", error.message);
          toast.error("Failed to sign in with Xero. Please try again.", {
            position: "bottom-center",
          });
          navigate("/sign-in");
        });
    }

    // Monitor auth state
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setLoading(false);
      if (!user && location.pathname === "/acc_profile") {
        navigate("/sign-in");
      }
    });

    return () => unsubscribe();
  }, [location, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/sign-in" element={<Signin />} />
          <Route path="/sign-up" element={<Signup />} />
          <Route path="/help_guide" element={<HelpGuide />} />
          <Route
            path="/acc_how_to_use"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated()}>
                <Ap_HTU />
              </PrivateRoute>
            }
          />
          <Route path="/myobtoxero" element={<RedirectToMYOB />} />
          <Route
            path="/acc_profile"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated()}>
                <Ap_Profile />
              </PrivateRoute>
            }
          />
          <Route
            path="/gst_form"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated()}>
                <Gst_form />
              </PrivateRoute>
            }
          />
          <Route
            path="/Ledger_Conversion"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated()}>
                <FileUpload />
              </PrivateRoute>
            }
          />
          <Route path="/pricing" element={<Pricing />} />
        <Route path="/ledger-pro" element={<LedgerPro />} />
          <Route path="/heading" element={<Heading />} />
          <Route path="/HelpPage" element={<HelpPage />} />
          <Route
            path="/gst-reconciliation"
            element={<GSTReconciliationProduct />}
          />
          <Route path="/request-demo" element={<RequestDemoPage />} />
          <Route path="/about-us" element={<About />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
}

export default App;